<template>
  <div>
    <div class="modal-header has-background-info-light">
      <h2 class="widow-header subtitle">{{ title }}</h2>
      <div class="box is-small">
        <!-- employee -->
        <p class="has-text-info">
          <i
            >{{ selectedVehicle.employee.hiddenFirstName }}
            {{ selectedVehicle.employee.hiddenLastName }}</i
          >
        </p>
        <!-- License plate, card -->
        <div class="columns">
          <!-- License plate -->
          <div class="column">
            <div class="has-text-centered"><label>Broj tablice:</label></div>
            <input
              class="
                input
                has-text-weight-bold has-text-centered has-background-info-light
              "
              type="text"
              v-model="selectedVehicle.licensePlate"
            />
          </div>
          <!-- card -->
          <div class="column">
            <div class="has-text-centered"><label>UHF kartica:</label></div>
            <input
              class="
                input
                has-text-weight-bold has-text-centered has-background-info-light
              "
              type="text"
              v-model="selectedVehicle.card"
            />
          </div>
        </div>
        <!-- vehicle type, charged date -->
        <div class="columns">
          <!-- vehicle type -->
          <div class="column">
            <div class="has-text-centered"><label>Tip vozila:</label></div>
            <div class="column has-text-centered is-four-fifths">
              <vue-select
                class="has-text-weight-bold has-background-info-light"
                type="text"
                label="name"
                :clearable="false"
                :options="types"
                :value="selectedVehicle.vehicleType"
                @input="typeSelected"
              />
            </div>
          </div>
          <!-- charged date -->
          <div class="column">
            <div class="has-text-centered"><label>Datum zaduženja:</label></div>
            <date-picker v-model="selectedVehicle.chargeDate" />
          </div>
        </div>
        <!-- Važi od do -->
        <!-- <div class="columns"> -->
        <!-- Važi od -->
        <!-- <div class="column">
            <div class="has-text-centered"><label>Važi od:</label></div>
            <date-pick
              class="date has-background-info-light"
              :format="'YYYY.MM.DD'"
              v-model="selectedVehicle.validFrom"
            />
          </div> -->
        <!-- Važi do -->
        <!-- <div class="column">
            <div class="has-text-centered"><label>Važi do:</label></div>
            <date-pick
              class="date has-background-info-light"
              :format="'YYYY.MM.DD'"
              v-model="selectedVehicle.validUntil"
            />
          </div> -->
        <!-- </div> -->
        <!-- Zadužuje ga -->
        <div class="columns">
          <!-- Zadužuje ga -->
          <div class="column">
            <div class="has-text-centered"><label>Zadužuje ga:</label></div>
            <div class="column has-text-centered">
              <vue-select
                class="has-text-weight-bold has-background-info-light"
                type="text"
                label="name"
                :clearable="true"
                :options="activeEmployees"
                v-model="superiorEmployee"
              />
            </div>
          </div>
        </div>
        <!-- GPS number, number of doors -->
        <div class="columns">
          <!-- GPS number -->
          <div class="column">
            <div class="has-text-centered"><label>GPS broj (imei):</label></div>
            <input
              class="
                input
                has-text-weight-bold has-text-centered has-background-info-light
              "
              type="text"
              v-model="selectedVehicle.gpsNumber"
            />
          </div>
          <!-- number of doors -->
          <div class="column">
            <div class="has-text-centered"><label>Broj vrata:</label></div>
            <input
              class="
                input
                has-text-weight-bold has-text-centered has-background-info-light
              "
              type="text"
              v-model="selectedVehicle.numberOfDoors"
            />
          </div>
        </div>
        <!-- Production year, note -->
        <div class="columns">
          <!-- Production year -->
          <div class="column">
            <div class="has-text-centered">
              <label>Godina proizvodnje:</label>
            </div>
            <date-picker type="year" v-model="selectedVehicle.productionYear" />
          </div>
          <!-- note -->
          <div class="column">
            <div class="has-text-centered"><label>Komentar:</label></div>
            <input
              class="
                input
                has-text-weight-bold has-text-centered has-background-info-light
              "
              type="text"
              v-model="selectedVehicle.note"
            />
          </div>
        </div>
        <!-- Weight, for terrain-->
        <div class="columns">
          <!-- Weight -->
          <div class="column">
            <div class="has-text-centered"><label>Nosivost:</label></div>
            <input
              class="
                input
                has-text-weight-bold has-text-centered has-background-info-light
              "
              type="text"
              v-model="selectedVehicle.weight"
            />
          </div>
          <!-- For terrain -->
          <div class="column">
            <div class="has-text-centered"><label>Za teren?</label></div>
            <input
              class="
                input
                has-text-weight-bold has-text-centered has-background-info-light
              "
              type="text"
              v-model="selectedVehicle.forTerrain"
            />
          </div>
        </div>
        <!-- Model, isPrivate-->
        <div class="columns">
          <!-- Model -->
          <div class="column">
            <div class="has-text-centered"><label>Model:</label></div>
            <input
              class="
                input
                has-text-weight-bold has-text-centered has-background-info-light
              "
              type="text"
              v-model="selectedVehicle.model"
            />
          </div>
          <!-- Is private -->
          <div class="column">
            <div class="has-text-centered">
              <label>Da li je vozilo privatno?</label>
            </div>
            <div class="is-four-fifths">
              <input
                class="
                  has-text-weight-bold
                  has-text-centered
                  has-background-info-light
                "
                type="checkbox"
                v-model="selectedVehicle.isPrivate"
              />
            </div>
          </div>
        </div>
        <!-- Buttons -->
        <div class="columns">
          <div v-show="isSaveAndProceedButtonVisible" class="column">
            <button
              class="button is-info is-light is-rounded"
              @click="saveAndProceedButtonClicked"
            >
              SAČUVAJ I NASTAVI
            </button>
          </div>
          <div class="column">
            <button
              class="button is-info is-light is-rounded"
              @click="saveAndCloseButtonClicked"
            >
              SAČUVAJ I ZATVORI
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
const { DateTime } = require("luxon");

export default {
  name: "EditCard",

  props: {
    title: String,
    selectedVehicle: Object,
    isSaveAndProceedButtonVisible: Boolean,
  },

  components: { DatePicker },

  data() {
    return {
      types: [
        {
          id: 1,
          name: "putničko",
        },
        {
          id: 2,
          name: "teretno",
        },
      ],
      activeEmployees: [],
      superiorEmployee: null,
    };
  },

  mounted() {
    this.superiorEmployee = this.$store.state.general.employees.find(
      (e) => e.id === this.selectedVehicle.employeeId
    );
    this.activeEmployees = this.$store.state.general.employees;

    // set productionYear
    this.selectedVehicle.productionYear !== null
      ? (this.selectedVehicle.productionYear = new Date(
          this.selectedVehicle.productionYear
        ))
      : (this.selectedVehicle.productionYear = null);
  },

  methods: {
    saveAndProceedButtonClicked() {
      this.arrangeResult();
      this.$emit("saveAndProceedButtonClicked", this.selectedVehicle);
    },
    saveAndCloseButtonClicked() {
      this.arrangeResult();
      this.$emit("saveAndCloseButtonClicked", this.selectedVehicle);
    },
    arrangeResult() {
      // employeeId
      this.superiorEmployee !== null
        ? (this.selectedVehicle.employee = this.superiorEmployee)
        : (this.selectedVehicle.employee = { id: null, name: null });

      // productionYear
      this.selectedVehicle.productionYear !== null
        ? (this.selectedVehicle.productionYear = DateTime.fromJSDate(
            this.selectedVehicle.productionYear
          )
            .toISO()
            .split("+")[0])
        : null;
    },
    typeSelected(val) {
      this.selectedVehicle.vehicleType = val.name;
    },
  },
};
</script>